
































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';

import { DataTableState, TableContext } from '@/typings/datatable';
import DataTableWithFilters, { DataTableFilter } from '@/components/datatable-filters.vue';

import { Product, ProductsApi } from '@/api';
import { ApiUtils, FilterParam } from '@/common/ApiUtils';

@Component({
	components: {
		secondaryNav,
		DataTableWithFilters,
	},
})
export default class ProductsList extends Vue {
	public state: DataTableState = {
		fields: [
			{ key: 'id', sortable: true },
			{ key: 'name', sortable: true },
			{ key: 'status', sortable: true },
			{ key: 'sites.0.name', label: 'Site', sortable: false },
			{ key: 'type', sortable: false, label: 'Type' },
		],
		loading: false,
		search: null,
		sortBy: 'id',
		primaryKey: 'id',
		sortDesc: false,
		perPage: 20,
		currentPage: 1,
		totalRows: 0,
	};

	public filters: DataTableFilter[] = [
		{
			label: 'Status',
			field: 'status',
			value: false,
			type: 'checkboxes',
			options: [
				{ text: 'Cancelled', value: 'cancelled' },
				{ text: 'Install', value: 'install' },
				{ text: 'Live', value: 'live' },
				{ text: 'Pending', value: 'pending' },
				{ text: 'Removed', value: 'removed' },
				{ text: 'Sign Off', value: 'sign-off' },
			],
		},
	];

	private api: ProductsApi;

	constructor() {
		super();
		this.api = new ProductsApi();
	}

	public reload() {
		this.$root.$emit('bv::refresh::table', 'products-datatable');
	}

	public clickTable(item: Product, newtab: boolean) {
		if (newtab) {
			const routeData = this.$router.resolve({
				name: 'products.water.view',
				params: { productId: item.id },
			} as any);
			window.open(routeData.href, '_blank');
		} else {
			this.$router.push({
				name: 'products.water.view',
				params: { productId: item.id },
			} as any);
		}
	}

	public async dataTableProvider(ctx: TableContext) {
		let data: any = [];
		try {
			const filters: FilterParam[] = this.filters.map((filter: DataTableFilter) => {
				return { field: filter.field, value: filter.value };
			});
			if (this.state.search) {
				// filters.push({field: 'supplierNumber', value: this.state.search});
				filters.push({ field: 'custom', value: this.state.search });
			}

			filters.push({ field: 'type', value: 'water' }); // fuel
			// filters.push({field: 'type', value: 'fuel'});

			const response = await this.api.getProducts(
				ApiUtils.queryOptions(filters, ctx, {
					params: { include: 'waterMeters,waterTanks,waterMonitors,sites' },
				}),
			);
			data = response.data.data;

			const products = [];
			data.forEach(product => {
				if (product.type !== 'water') {
					products.push(product);
				}
			});

			data = products;

			this.state.totalRows = response.data.meta.total || 0;
		} catch (e) {
			this.state.totalRows = 0;
		}
		return data;
	}
}
